import { createMediaButton } from "../create-media-button.js";
import { PiPButtonCore, PiPButtonDataAttrs } from "@videojs/core";
import { selectPiP } from "@videojs/core/dom";
//#region src/ui/pip-button/component.tsx
/** A button that toggles picture-in-picture. */
const PiPButton = createMediaButton({
	displayName: "PiPButton",
	core: PiPButtonCore,
	stateAttrMap: PiPButtonDataAttrs,
	selector: selectPiP,
	action: (core, state) => core.toggle(state),
	hotkeyAction: "togglePictureInPicture",
	isSupported: (state) => !state.hidden
});
//#endregion
export { PiPButton };

//# sourceMappingURL=component.js.map